import DropdownMultiselect from './dropdown-multiselect-kt.directive';
import AutocompleteMultiselect from './autocomplete-multiselect-kt.directive';
import AutocompleteMultiselectValidator from './autocomplete-multiselect-kt.validator';

const MODULE_NAME = 'App.Atc.Directives';
const module = angular
    .module(MODULE_NAME, [])
    .directive('dropdownMultiselectKt', DropdownMultiselect)
    .directive('autocompleteMultiselectKt', AutocompleteMultiselect)
    .directive('ktAutocompleteMultiselectValidator', AutocompleteMultiselectValidator);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/atc/directives/atc-directives-module.js